import React from 'react';

import RAcompType from "./RAcompType";

class RAcomp extends React.Component {
  constructor(){
    super();
    this.save = this.save.bind(this);
    this.overrideComp = this.overrideComp.bind(this);
  }
  save(type, val, sub){
    const newD = {...this.props.d};
    if(sub)
    {
      if(typeof newD[sub] !== "object")
      {
        newD[sub] = [];
      }
      newD[sub][type] = val;
    }else{
      newD[type] = val;
    }
    console.log("Save()", type, val, sub ,newD);
    this.props.update(newD);
  }
  overrideComp(data)
  {
    this.props.update(data);
  }
	render(){
    const p = this.props;
    const d = this.props.d;
		return (<tbody key={"comp" + p.i}>
              <tr>
                <td>
                  <select name="type[]" defaultValue={d.type} onChange={(e) => this.save("type", e.target.value)}>
                    <option value="NaN"></option>
                    {
                        Object.keys(p.types).map((d,key) => <option key={"type" + key + d} value={p.types[d]}>{d}</option>)
                    }
                  </select>
                </td>
                <td>
                  <input name="textDK[]" placeholder="DK" defaultValue={d.text.DK} disabled={d.dbID || d.type === "inputs"} onChange={(e) => this.save("DK", e.target.value, "text")}/><br/>
                  <input name="textUK[]" placeholder="UK" defaultValue={d.text.UK} disabled={d.dbID || d.type === "inputs"} onChange={(e) => this.save("UK", e.target.value, "text")}/><br/>
                </td>
                <td>
                  <select style={d.type === "yesNo" ? {} : {"display": "none"}} disabled={d.dbID} defaultValue={d.correct} onChange={(e) => this.save("correct", Number(e.target.value))}>
                    <option value="1">Ja</option>
                    <option value="0">Nej</option>
                  </select>
                </td>
                <td>
                  <input type="checkbox" value="1" defaultChecked={d.comment} disabled={d.dbID} name="comment[]" onChange={(e) => this.save("comment", e.target.checked)}/>
                </td>
                <td>
                  <input type="checkbox" value="1" defaultChecked={d.upload} disabled={d.dbID} name="upload[]" onChange={(e) => this.save("upload", e.target.checked)}/>
                </td>
                <td>
                  <input type="checkbox" value="1" style={d.type === "title" ? {} : {"visibility": "hidden"}} onChange={(e) => this.save("shuffle", e.target.checked)} defaultChecked={d.shuffle} disabled={d.dbID} name="upload[]"/>
                </td>
                <td>
                  {
                    this.props.i > 0 ?
                      <button onClick={(e) => {
                        e.preventDefault();
                        this.props.move(this.props.i, this.props.i - 1);
                      }}>&#8593;</button>
                    : null
                  }
                  {
                    this.props.i !== (this.props.amount - 1) ?
                      <button onClick={(e) => {
                        e.preventDefault();
                        this.props.move(this.props.i, this.props.i + 1);
                      }}>&#8595;</button>
                    : null
                  }
                </td>
              </tr>
              <tr colSpan="6">
                <RAcompType d={d} p={p} update={this.save} overrideComp={this.overrideComp}/>
              </tr>
            </tbody>);
	}
}

export default RAcomp;


// WEBPACK FOOTER //
// ./src/components/RAcomp.js